import { routes } from 'utils/routes'
import { Language } from 'types/language'
import { I18nUSP } from 'types/i18n'
import { isValidLowercaseLanguage } from 'utils/format'

/**
 * Get the USP link from the i18n key
 * @param {I18nUSP["key"]} key
 * @param {string} language
 * @returns {string}
 */
export const getUspLinkFromKey = (key: I18nUSP['key'], language: string): string => {
  const locale = isValidLowercaseLanguage(language) ? language : Language.DUTCH

  switch (key) {
    case 'fun': {
      return routes(locale).uspsFun
    }
    case 'durable': {
      return routes(locale).uspsLocal
    }
    case 'service': {
      return routes(locale).uspsCustomerCare
    }
    case 'tariff': {
      return routes(locale).uspsFairPrice
    }
  }
}
